import { IOrderMerch } from "../interface/IOrderDto"

export const orderMerch: IOrderMerch = {
  acceptSpecialInstruction: true,
  address: "",
  banner: "",
  isAsapOnly: false,
  merchDecideConfirmedTime: false,
}
